export enum DocumentStatus {
	DOCUMENT_CREATED = 'documentCreated',
	DOCUMENT_FAILED = 'documentFailed',
}
